import { Modal } from "antd";
import FooterModal from "ui/components/Button/FooterModal";
import { useForm } from "react-hook-form";
import { PessoaTipo } from "core/features/pessoas/typings";
import DadosGerais from "components/Features/Empresa/FormEmpresa/DadosGerais";
import { EmpresaResponse, TipoCadastroEmpresa } from "resources/types/empresa";
import { showSuccess, showErrorAxios } from "infra/helpers/alerta";
import { useSaveFornecedor } from "features/fornecedores/hooks";
import Field from "ui/components/Input/Field";
import { Switch } from "@chakra-ui/react";

interface ModalCadastroPessoaProps {
  isOpen: boolean;
  onClose: () => any;
  onSaved?: ({ id, nome }: { id: string; nome: string }) => any;
}

export default function ModalCadastroPessoa({
  isOpen,
  onClose,
  onSaved,
}: ModalCadastroPessoaProps) {
  const { control, handleSubmit, watch, setValue } = useForm<EmpresaResponse>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ativo: true,
      endereco: {},
      pessoa: {
        contatos: [],
      },
      pessoaTipo: PessoaTipo.Juridica,
    },
  });

  const { isLoading: isLoadingSave, mutate: handleSave } = useSaveFornecedor();

  const onSubmit = (form: EmpresaResponse) => {
    const formattedData = form;

    handleSave(
      {
        ...formattedData,
        pessoa: {
          ...formattedData.pessoa,
          contatos: Array.isArray(formattedData.pessoa.contatos)
            ? formattedData.pessoa.contatos
            : [],
        },
      },
      {
        onSuccess: ({ data }) => {
          showSuccess();
          onSaved?.({ id: data.pessoaId, nome: formattedData.pessoa.nome! });
          onClose();
        },
        onError: (err) => {
          showErrorAxios(err);
        },
      }
    );
  };

  const form = watch();
  return (
    <Modal
      width="900px"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onSubmit={handleSubmit(onSubmit)}
          onClose={() => {
            onClose();
          }}
          isLoadingSave={isLoadingSave}
          isDisabled={false}
          showRegisterAnother={false}
          primaryButtonText="Salvar"
          buttonCancelarText="Fechar"
        />
      }
      centered
      title="Dados Cadastrais"
      visible={isOpen}
      onCancel={onClose}
    >
      <>
        <DadosGerais
          control={control}
          setField={setValue}
          form={form}
          tipoCadastroEmpresa={TipoCadastroEmpresa.Fornecedor}
          watch={watch}
        />
        <Field
          name="ativo"
          control={control}
          render={({ field }) => (
            <Switch
              isChecked={!!field.value}
              onChange={() => field.onChange(!field.value)}
            >
              Fornecedor ativo
            </Switch>
          )}
        />
      </>
    </Modal>
  );
}
